export const EMBRION_API_URL = 'https://embtec.herokuapp.com/api/';
//https://embrion-api.herokuapp.com/api/ HMG
//https://embtec.herokuapp.com/api/ PRD
